import { gql } from '@apollo/client'

export const CREATE_REVIEWER_OF_EMPLOYEE_RELATION = gql`
  mutation CreateReviewerOfEmployee($revEmpInput: ReviewerOfEmployeesInput!) {
    createReviewerOfEmployee(revEmpInput: $revEmpInput) {
      id
    }
  }
`

export const DELETE_REVIEWER_OF_EMPLOYEE_RELATION = gql`
  mutation DeleteReviewerOfEmployee($relationId: HashedId!) {
    deleteReviewerOfEmployee(relationId: $relationId)
  }
`
